import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { enforceSlash } from '../../utils/helpers';
import { useStores } from '../../hooks/use-stores';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SimpleTable from '../../components/super/SimpleTable';
import { Fab, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
    fab: {
        position: 'fixed',
        bottom: theme.spacing(4),
        right: theme.spacing(4),
    },
}));
function ThreatAreas() {
    const { threatAreasStore, commonStore } = useStores();
    const { loadingThreatAreas, threatAreas, error } = threatAreasStore;
    const { pathname } = useLocation();
    const baseUrl = enforceSlash(pathname);
    const navigate = useNavigate();
    const classes = useStyles();

    const loadData = async () => {
        threatAreasStore.loadThreatAreas();
    };

    const removeThreatArea = async (id) => {
        commonStore.showDeleteConfirm('Threat Area', id, async () => {
            await threatAreasStore.removeThreatArea(id);
            await threatAreasStore.loadThreatAreas();
        });
    };

    useEffect(() => {
        loadData();
    }, []);

    const columns = React.useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'id',
                Cell: (x) => (
                    <Link to={`${baseUrl}${x.value}/edit`}>
                        {x.value}
                    </Link>
                ),
            },
            {
                Header: 'Code',
                accessor: 'threatAreaCode',
                Cell: (x) => (
                    <Link
                        to={`${baseUrl}${x.row.original.id}/edit`}
                    >
                        {x.value}
                    </Link>
                ),
            },
            {
                Header: 'Name',
                accessor: 'threatAreaName',
                Cell: (x) => (
                    <Link
                        to={`${baseUrl}${x.row.original.id}/edit`}
                    >
                        {x.value}
                    </Link>
                ),
            },
            {
                Header: '',
                id: 'delete',
                Cell: (x) => (
                    <IconButton
                        aria-label="delete"
                        onClick={() => removeThreatArea(x.row.original.id)}
                        color="secondary"
                    >
                        <DeleteIcon />
                    </IconButton>
                ),
            },
        ],
        [baseUrl]
    );

    return (
        <Grid
            container
            direction="row"
            justify="center"
            align="center"
            spacing={2}
        >
            <Grid item xs={12}>
                <Box mt={4}>
                    <Typography variant="h2">ThreatAreas</Typography>
                </Box>
            </Grid>
            <Tooltip
                title="Create Threat Area"
                aria-label="add"
                placement="left"
            >
                <Fab
                    color="primary"
                    onClick={() => navigate('/content/threatareas/create')}
                    className={classes.fab}
                >
                    <AddIcon />
                </Fab>
            </Tooltip>
            {loadingThreatAreas ? (
                <ThemedSpinner />
            ) : threatAreas && threatAreas.length > 0 ? (
                <Grid item xs={12}>
                    <SimpleTable
                        columns={columns}
                        data={threatAreas}
                        needsFilter={true}
                    />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <Typography>No tags found :(</Typography>
                </Grid>
            )}
            {error && (
                <Grid item>
                    <ErrorMessage error={error} />
                </Grid>
            )}
        </Grid>
    );
}

export default observer(ThreatAreas);
